
/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ProjectSpecificBillingInfoParam,
  ProjectSpecificBillingInfoResource,
  ValidationError,
} from '../models';
import {
    ProjectSpecificBillingInfoParamFromJSON,
    ProjectSpecificBillingInfoParamToJSON,
    ProjectSpecificBillingInfoResourceFromJSON,
    ProjectSpecificBillingInfoResourceToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface GetProjectSpecificBillingInfoRequest {
    projectId: string;
}

export interface PostProjectSpecificBillingInfoRequest {
    projectId: string;
    projectSpecificBillingInfoParam: ProjectSpecificBillingInfoParam;
}

/**
 * 
 */
export class ProjectBillingInfoApi extends runtime.BaseAPI {

    /**
     * Fetch the project specific billing information
          */
    async getProjectSpecificBillingInfoRaw(requestParameters: GetProjectSpecificBillingInfoRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProjectSpecificBillingInfoResource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getProjectSpecificBillingInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProjectSpecificBillingInfoResource>({
            path: `/project-client/api/project/{projectId}/billing-info`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProjectSpecificBillingInfoResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Fetch the project specific billing information
          */
    async getProjectSpecificBillingInfo(requestParameters: GetProjectSpecificBillingInfoRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProjectSpecificBillingInfoResource> {
        const response = await this.getProjectSpecificBillingInfoRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update the project billing info
          */
    async postProjectSpecificBillingInfoRaw(requestParameters: PostProjectSpecificBillingInfoRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProjectSpecificBillingInfoResource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling postProjectSpecificBillingInfo().'
            );
        }

        if (requestParameters['projectSpecificBillingInfoParam'] == null) {
            throw new runtime.RequiredError(
                'projectSpecificBillingInfoParam',
                'Required parameter "projectSpecificBillingInfoParam" was null or undefined when calling postProjectSpecificBillingInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ProjectSpecificBillingInfoResource>({
            path: `/project-client/api/project/{projectId}/billing-info`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProjectSpecificBillingInfoParamToJSON(requestParameters['projectSpecificBillingInfoParam']),
        }, initOverrides);

        if (response._data) { response._data=ProjectSpecificBillingInfoResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Update the project billing info
          */
    async postProjectSpecificBillingInfo(requestParameters: PostProjectSpecificBillingInfoRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProjectSpecificBillingInfoResource> {
        const response = await this.postProjectSpecificBillingInfoRaw(requestParameters, initOverrides);
        return response._data;
    }

}
